import { Modal } from 'bootstrap'

export class ModalManager {
    constructor() {
        this.modalInstances = new Map()
        this.activeModals = []
    }

    initModal(modalId, options = {}) {
        const modalElement = document.getElementById(modalId)

        if (!modalElement) {
            console.error(`Modal element with id ${modalId} not found`)
            return
        }

        if (!this.modalInstances.has(modalId)) {
            const modalInstance = new Modal(modalElement, {
                backdrop: options.backdrop ?? 'static',
                keyboard: options.keyboard ?? false,
                focus: options.focus ?? true,
            })

            this.modalInstances.set(modalId, modalInstance)

            modalElement.addEventListener('hidden.bs.modal', () => {
                this.handleModalHidden(modalId)
            })
        }
    }

    showModal(modalId, options = {}) {
        const modalElement = document.getElementById(modalId)
        if (!modalElement) {
            console.warn(`Modal element with id ${modalId} not found, will try to initialize later`)
            return
        }

        if (!this.modalInstances.has(modalId)) {
            this.initModal(modalId, options)
        }

        const modalInstance = this.modalInstances.get(modalId)
        if (modalInstance) {
            if (this.activeModals.length > 0) {
                const currentModalId = this.activeModals[this.activeModals.length - 1]
                const currentModal = this.modalInstances.get(currentModalId)
                currentModal?.hide()
            }

            modalInstance.show()
            this.activeModals.push(modalId)
        }
    }

    hideModal(modalId) {
        const modalInstance = this.modalInstances.get(modalId)
        if (modalInstance) {
            modalInstance.hide()

            // ActiveModals listesinden kaldır
            const index = this.activeModals.indexOf(modalId)
            if (index !== -1) {
                this.activeModals.splice(index, 1)
            }
        }
    }

    handleModalHidden(modalId) {
        const index = this.activeModals.indexOf(modalId)
        if (index !== -1) {
            this.activeModals.splice(index, 1)
        }

        // Eğer başka bir modal varsa, onu göster
        if (this.activeModals.length > 0) {
            const previousModalId = this.activeModals[this.activeModals.length - 1]
            const previousModal = this.modalInstances.get(previousModalId)
            const modalElement = document.getElementById(previousModalId)

            if (previousModal && modalElement) {
                previousModal.show()
            }
        }
    }

    destroyModal(modalId) {
        const modalInstance = this.modalInstances.get(modalId)
        if (modalInstance) {
            try {
                modalInstance.dispose()
            } catch (error) {
                console.warn(`Error disposing modal ${modalId}:`, error)
            }
            this.modalInstances.delete(modalId)

            const index = this.activeModals.indexOf(modalId)
            if (index !== -1) {
                this.activeModals.splice(index, 1)
            }
        }
    }

    destroyAll() {
        this.modalInstances.forEach((modal, id) => {
            this.destroyModal(id)
        })
        this.activeModals = []
    }
}

export const modalManager = new ModalManager()
